/**
 * AppConfigService — fetches runtime config from backend at startup
 * so compile-time FEATURE_FLAGS never drift from backend env vars.
 */
import { ApiClient } from './ApiClient.js';

let config = null;
let promise = null;

const DEFAULTS = {
    azureAdEnabled: false,
    autoProvisionEnabled: false,
};

export class AppConfigService {
    static async load() {
        if (config) return config;
        if (promise) return promise;
        promise = (async () => {
            try {
                const res = await fetch(`${ApiClient.getBaseUrl()}/api/v1/config`);
                if (!res.ok) throw new Error(`Config endpoint returned ${res.status}`);
                const data = await res.json();
                config = { ...DEFAULTS, ...data };
            } catch {
                config = { ...DEFAULTS };
            }
            return config;
        })();
        return promise;
    }

    static get() {
        return config || DEFAULTS;
    }

    static isAzureAdEnabled() {
        return AppConfigService.get().azureAdEnabled === true;
    }

    static isAutoProvisionEnabled() {
        return AppConfigService.get().autoProvisionEnabled === true;
    }
}
